import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import DashboardContainer from '../../../../presentation/DashboardContainer';
import layout from './layout.json';

export default class CallsAttemptedServedDashboardList extends React.Component {
  constructor( props ) {
    super( props );

    this.onRenderData = this.onRenderData.bind( this );
  }
  
  onRenderCouponCountsDayByHourAvailableDifferences( data ) {
    return data;
  }

  onRenderData( key, data ) {
    if ( key === 'Coupon Counts Day By Hour Available Differences' ) {
      return this.onRenderCouponCountsDayByHourAvailableDifferences( data[ 0 ] );
    }
    return [];
  }

  render( ) {
    return (
      <PageAuthorize groups={['Administrators','Operations','Management','CallsAttemptedServed','Dashboards']} >
        <DashboardContainer layout={layout} onRenderData={this.onRenderData} onGridFormatItem={this.onGridFormatItem} />
      </PageAuthorize>
    );
  }
}



// WEBPACK FOOTER //
// ./src/content/dashboards/callsaattemptedserved/components/CallsAttemptedServedDashboardList.js